<template>
  <div>
    <loading
      :active.sync="loading"
      :can-cancel="false"
      :is-full-page="false"
      :color="this.$primaryColor"
    ></loading>
    <p class="text-center font-bold">
      Select two images to perform face matching
    </p>
    <div class="mt-6 lg:flex justify-around lg:space-x-4 space-x-0">
      <div>
        <div>
          <label
            for="image1"
            class="block text-sm font-medium leading-5 text-gray-700"
          >
            Face image 1
          </label>
          <div class="mt-1 rounded-md shadow-sm">
            <input
              id="image1"
              type="file"
              name="image1"
              accept="image/*"
              required
              class="w-full"
              @change="assingImgInput"
            />
          </div>
          <div class="error" v-if="errors.image1">
            {{ errors.image1 }}
          </div>
        </div>
        <div class="text-center">
          <button
            class="
              justify-center
              cursor-pointer
              inline-flex
              px-4
              py-2
              text-base
              transition
              duration-150
              ease-in-out
              border border-gray-600
              rounded-md
              mt-3
            "
            @click="takePhoto(1)"
          >
            Or Take Photo
          </button>
          <img :src="img1" class="max-w-xs max-h-full mt-3 mx-auto" />
        </div>
      </div>
      <div>
        <div>
          <label
            for="image2"
            class="block text-sm font-medium leading-5 text-gray-700"
          >
            Face image 2
          </label>
          <div class="mt-1 rounded-md shadow-sm">
            <input
              id="image2"
              type="file"
              name="image2"
              accept="image/*"
              required
              class="w-full"
              @change="assingImgInput"
            />
          </div>
          <div class="error" v-if="errors.image2">
            {{ errors.image2 }}
          </div>
          <div class="text-center">
            <button
              class="
                justify-center
                cursor-pointer
                inline-flex
                px-4
                py-2
                text-base
                transition
                duration-150
                ease-in-out
                border border-gray-600
                rounded-md
                mt-3
              "
              @click="takePhoto(2)"
            >
              Or Take Photo
            </button>
            <img :src="img2" class="max-w-xs max-h-full mt-3 mx-auto" />
          </div>
        </div>
      </div>
    </div>

    <div class="text-center mt-6">
      <button class="btn-primary" @click="match()">Match</button>
    </div>
    <div v-if="score != null" class="text-center">
      <p
        class="
          mt-6
          text-center
          font-bold
          text-xl
          border
          p-4
          rounded-xl
          inline-block
        "
        :class="
          score > 0.4
            ? 'bg-emerald-50 border-emerald-500'
            : 'bg-red-50 border-red-500'
        "
      >
        {{ score > 0.4 ? `Match (${score})` : `No Match (${score})` }}
      </p>
    </div>

    <modal :show="showWebCam" @closeModal="closeModal()">
      <webcam :showCam="showWebCam" @img="setImg" />
    </modal>
  </div>
</template>

<script>
import webcam from "../../Components/webCam.vue";
import modal from "../../Components/modal.vue";

export default {
  components: { webcam, modal },
  props: ["option"],
  data() {
    return {
      errors: {
        image1: null,
        image2: null,
      },
      showWebCam: false,
      openImage: null,
      img1: null,
      img2: null,
      score: null,
      loading: false,
    };
  },
  created() {},
  methods: {
    takePhoto(num) {
      this.openImage = num;
      this.showWebCam = true;
    },
    closeModal() {
      this.openImage = null;
      this.showWebCam = false;
    },
    setImg(img) {
      if (this.openImage == 1) {
        this.img1 = img;
        this.errors.image1 = null;
      } else {
        this.img2 = img;
        this.errors.image2 = null;
      }
      this.showWebCam = false;
    },
    match() {
      if (this.img1 == null) {
        this.errors.image1 = "Image required";
      }
      if (this.img2 == null) {
        this.errors.image2 = "Image required";
      }
      if (this.img1 == null || this.img2 == null) {
        return;
      }
      this.errors.image1 = null;
      this.errors.image2 = null;

      this.loading = true;
      this.axios
        .post("/user/api/face/match", {
          img1: this.img1,
          img2: this.img2,
          option: this.option
        })
        .then((response) => {
          this.loading = false;
          if (response.data.message != undefined) {
            this.$store.commit("showFlashMessage", {
              message: response.data.message,
              type: response.data.message_type,
            });
          } else {
            this.score = response.data.score.toFixed(2);
          }
        })
        .catch((e) => {
          this.loading = false;
          this.$store.commit("showFlashMessage", {
            message: e,
            type: "danger",
          });
        });
    },
    async assingImgInput(event) {
      this.openImage = event.target.id == "image1" ? 1 : 2;
      let imgBase64 = await this.getBase64(event.target.files[0]);
      this.setImg(imgBase64);
      this.openImage = null;
    },
    async getBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
      });
    },
  },
};
</script>

<style>
.modalVue,
.modalVue > * {
  padding: 0;
  margin: 0;
}

.closeModal {
  background-color: rgba(75, 85, 99, 0.5);
  padding: 1rem;
}

.closeModal svg {
  color: white;
}
</style>
